import { CellAlign, HeadCell } from '@dfl/mui-admin-layout';
import { AvatarNameCell } from 'modules/common/components/AvatarNameCell';
import ProductInventoryStoreUpdate from 'modules/inventory/product-stock/components/ProductInventoryStoreUpdate/ProductInventoryStoreUpdate';
import { ProductWarehouseArea } from '../components/ProductWarehouseArea';
import { STOCK_PERMISSIONS } from 'modules/inventory/product-stock/constants/stock.permissions';
import { WAREHOUSE_PERMISSIONS } from 'modules/inventory/warehouse/constants';
import { IStock } from 'modules/inventory/warehouse/interfaces';
import { ProductStockVisiblePicker } from 'modules/inventory/product-stock/components/StockVisiblePicker';
import ActivePoint from 'components/ActivePoint/ActivePoint';
import { Stack } from '@mui/material';
import { avgDailyUnitsColumn, coverageDaysColumn, coverageStatusColumn } from 'modules/reports/constants/coverage-report.columns';

export const productNameColumn: HeadCell = {
  field: 'warehouseName',
  headerName: 'product:section.inventory.warehouse',
  width: 200,
  renderCell: (warehouseName: string, data: any) => (
    <Stack sx={{ flexDirection: 'row', gap: { xs: 1, lg: 1.5 }, alignItems: 'center' }}>
      <ActivePoint value={data?.warehouseVisible} />
      <AvatarNameCell
        link={`/inventory/warehouses/${data?.warehouse as string}/general`}
        name={warehouseName}
        hideImage
        permissions={[WAREHOUSE_PERMISSIONS.WAREHOUSE_VIEW]}
      />
    </Stack>
  ),
};

export const productWarehouseAreaColumn: HeadCell = {
  field: 'warehouseArea',
  headerName: 'product:section.inventory.warehouseArea',
  component: ProductWarehouseArea,
};

export const productAvailableColumn: HeadCell = {
  field: 'available',
  headerName: 'product:section.inventory.available',
  align: CellAlign.CENTER,
};
export const productReservationColumn: HeadCell = {
  field: 'reservation',
  headerName: 'product:section.inventory.reservation',
  align: CellAlign.CENTER,
};

export const productStockColumn: HeadCell = {
  field: 'stock',
  headerName: 'product:section.inventory.stock',
  align: CellAlign.CENTER,
};

export const stockVisibilityColumn: HeadCell<IStock> = {
  field: 'visible',
  align: CellAlign.CENTER,
  headerName: 'warehouse:fields.visibility',
  component: ProductStockVisiblePicker,
};

export const productStockActionColumn: HeadCell = {
  field: 'actions',
  headerName: 'common:actions',
  width: 150,
  align: CellAlign.CENTER,
  sortable: false,
  component: ProductInventoryStoreUpdate,
  permissions: [STOCK_PERMISSIONS.STOCK_WRITE],
};

export const inventoryProductColumns: HeadCell[] = [
  productNameColumn,
  productWarehouseAreaColumn,
  productAvailableColumn,
  productReservationColumn,
  productStockColumn,
  avgDailyUnitsColumn,
  coverageStatusColumn,
  coverageDaysColumn,
  stockVisibilityColumn,
  productStockActionColumn,
];
